import React, { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../../contexts/LoginContext";
import Pagination from "../../../components/pagination/Pagination";
import routes from "../../../config/routes-config";
import SearchBar from "../../../components/SearchBar";
import FilterBtn from "./FilterButton";
import ProjectsList from "./ProjectsList";
import { getProjects } from "./api-handlers";

// TODO :: VVIMP Ask Avinash to send me total page count in api call
const AllProjects = () => {
  const { user, userAuthStatus, departments, domains, activeTags } =
    useContext(LoginContext);

  const [projectsData, setProjects] = useState({
    currentPage: 0,
    totalPages: 0,
    totalItems: 0,
    tutorials: [],
  });

  const [queryParams, setQueryParams] = useState(
    new URLSearchParams("page=0&size=10&sortBy=id")
  );

  const [filtersApplied, setFiltersApplied] = useState({});

  useEffect(() => {
    if (userAuthStatus && user !== null) {
      getProjects(
        routes.project.allProjects,
        user.token,
        queryParams,
        setProjects
      );
    }
  }, [userAuthStatus, user, queryParams]);

  const handleAddAndUpdateFilter = (filterKey, filterValue) => {
    setFiltersApplied((previousState) => {
      return { ...previousState, [filterKey]: filterValue };
    });

    setQueryParams((previousState) => {
      previousState.set(filterKey, filterValue);
      return previousState;
    });

    const newQueryParams = new URLSearchParams(queryParams);
    if (filterKey === "orderBy" && filterValue === "Ascending") {
      newQueryParams.set(filterKey, true);
    } else if (filterKey === "orderBy" && filterValue === "Descending") {
      newQueryParams.set(filterKey, false);
    } else {
      newQueryParams.set(filterKey, filterValue);
    }

    getProjects(
      routes.project.allProjects,
      user.token,
      newQueryParams,
      setProjects
    );
  };

  const handleRemoveFilter = (filterKey) => {
    setFiltersApplied((previousState) => {
      delete previousState[filterKey];
      return previousState;
    });

    setQueryParams((previousState) => {
      previousState.delete(filterKey);
      return previousState;
    });

    const newQueryParams = new URLSearchParams(queryParams);
    newQueryParams.delete(filterKey);

    getProjects(
      routes.project.allProjects,
      user.token,
      newQueryParams,
      setProjects
    );
  };

  const handleSearch = (query) => {
    if (query.trim() === "") {
      setQueryParams((previousState) => {
        previousState.delete("title");
        return previousState;
      });
      return;
    }

    setQueryParams((previousState) => {
      previousState.set("title", query);
      return previousState;
    });

    const newQueryParams = new URLSearchParams(queryParams);
    newQueryParams.set("title", query);

    getProjects(
      routes.project.allProjects,
      user.token,
      newQueryParams,
      setProjects
    );
  };

  const prevPage = () => {
    setProjects((previousState) => {
      if (
        previousState.currentPage > 1 &&
        previousState.currentPage <= previousState.totalPages
      ) {
        previousState.currentPage -= 1;
      }

      return previousState;
    });
  };

  // Change page according to user click
  const paginate = (pageNumber) =>
    setProjects((previousState) => {
      previousState.currentPage = pageNumber;
      return previousState;
    });

  const nextPage = () => {
    setProjects((previousState) => {
      if (
        previousState.currentPage >= 1 &&
        previousState.currentPage < previousState.totalPages
      ) {
        previousState.currentPage += 1;
      }

      return previousState;
    });
  };

  return (
    <div className="flex flex-col w-full h-full justify-start ">
      <div className="flex flex-col justify-center items-center mt-16">
        <div className="w-[75%] px-[12.5%]">
          <SearchBar
            placeholder="Enter name of a project to begin search"
            callbackSearch={handleSearch}
          />
        </div>
      </div>

      <div className="flex flex-row justify-center mt-12 mb-12">
        <div className="flex flex-row justify-between items-end w-[50%]">
          <FilterBtn
            btnName={"Department"}
            btnOptions={departments.map(
              (department) => department.departmentName
            )}
            handleAddAndUpdateFilter={handleAddAndUpdateFilter}
          />

          <FilterBtn
            btnName={"Domain"}
            btnOptions={domains}
            handleAddAndUpdateFilter={handleAddAndUpdateFilter}
          />

          <FilterBtn
            btnName={"Year"}
            btnOptions={["First Year", "Second Year", "Third Year", "B.Tech"]}
            handleAddAndUpdateFilter={handleAddAndUpdateFilter}
          />

          <FilterBtn
            btnName={"Tags"}
            btnOptions={activeTags}
            handleAddAndUpdateFilter={handleAddAndUpdateFilter}
          />

          <FilterBtn
            btnName={"orderBy"}
            btnOptions={["Ascending", "Descending"]}
            handleAddAndUpdateFilter={handleAddAndUpdateFilter}
          />
        </div>
      </div>

      <div className="bg-gray-200 flex flex-row h-12 items-center">
        <span className="text-xl pl-[12.5%] text-center">Filters |</span>
        {Object.entries(filtersApplied).map(([key, value], index) => (
          <div key={index} className="flex flex-row mx-6">
            <div className="bg-gray-400 rounded-md px-4">
              <span>{value}</span>
              <button
                onClick={(event) => {
                  handleRemoveFilter(key);
                }}
                className="text-xl ml-2 align-center cursor-pointer alert-del"
              >
                &times;
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col justify-center items-center mt-8 mb-8">
        <ProjectsList projects={projectsData.tutorials} role={user} />

        {/* TODO :: Ask Avinash to also supply total no of pages from the API Request And ask him to correct his logic*/}
        <Pagination
          currentPage={projectsData.currentPage}
          totalPages={projectsData.totalPages}
          prev={prevPage}
          paginate={paginate}
          next={nextPage}
        />
      </div>
    </div>
  );
};

export default AllProjects;
